
export const LIPShapeLabels = [
  "ee (teeth) ",
  "eh (bet, red) ",
  "schwa (a in sofa) ",
  "ah (bat, cat) ",
  "oh (or, boat) ",
  "oo (blue) wh in wheel ",
  "y (you) ",
  "s, ts ",
  "f, v ",
  "n, ng ",
  "th ",
  "m, p, b ",
  "t, d ",
  "j, sh ",
  "l, r ",
  "k, g ",
];
